<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-rx"
  [title]="'P00032.card.RX' | translate"
  [mode]="(actionStack!.getValue('alSMesureRx') / 100).toFixed(0) + ' mV'"
  (onPress)="this.openProductModal()"
  [color]="
    buttons[this.actionStack!.getValue('alCEtatProduit')].color! | translate
  "
  [status]="
    buttons[this.actionStack!.getValue('alCEtatProduit')].title! | translate
  "
  [statusMode]="buttons[this.actionStack!.getValue('alCEtatProduit')].status!"
>
</app-small-tuile>

<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-ph"
  [title]="'dashboard.ph' | translate"
  [mode]="(actionStack!.getValue('alSMesurePh') / 100).toFixed(1) + ' pH'"
  (onPress)="this.openProductModal()"
  [color]="
    buttons[this.actionStack!.getValue('alCEtatProduit')].color! | translate
  "
  [status]="
    buttons[this.actionStack!.getValue('alCEtatProduit')].title! | translate
  "
  [statusMode]="buttons[this.actionStack!.getValue('alCEtatProduit')].status!"
>
</app-small-tuile>
